import { lazy } from "react";
import Loadable from "components/Loadable";
import { routeConstants } from "services/keyConstants";

// Lazy-loaded components
const ListOfExternalOrigin = Loadable(lazy(() => import("../ListOfExternalOrigin")));
const MasterListOfDocuments = Loadable(lazy(() => import("../MasterListOfDocuments")));

const ControlOfDocumentRoute = [
  {
    path: routeConstants.CONTROL_OF_DOCUMENT,
    children: [
      {
        path: ":id",
        element: <ListOfExternalOrigin />,
      },
      {
        path: "master-list-of-document/:id",
        element: <MasterListOfDocuments />,
      },
    ],
  },
];

export default ControlOfDocumentRoute;
